<template>
  <div class="pagamento">
    <Topo @selecionar-assinatura="selecionarAssinatura" />
    <div class="row">
      <div class="col-md-4 mt-3">
        <Menu />
      </div>
      <!-- Conteudo das views -->
      <div class="col-md-8 mt-3">
        <!-- conteudo views -->
        <table class="table table-responsive font-tabela-peq">
          <thead class="thead">
            <tr>
              <th colspan="6" class="text-right">
                <a href="#" @click="printInvoices" v-show="subscription != null && subscription.paymentType == 'TICKETS'"
                  class="link-padrao">Gerar Carnê</a>
              </th>
            </tr>
            <tr>
              <th scope="col">Competência</th>
              <th scope="col">Vencimento</th>
              <th scope="col">Valor</th>
              <th scope="col">Status</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(invoice, index) in invoices" :key="invoice.id"
              :class="[invoice.outDate ? 'invoice-pendent' : '']">
              <td class="letra-menor align-middle">{{invoice.competenceBegin}} a {{invoice.competenceEnd}}</td>
              <td class="align-middle">{{invoice.dueDate}}</td>
              <td class="align-middle">{{invoice.amountFmt}}</td>
              <td class="align-middle">
                <span v-if="invoice.status == 'OPENED' && invoice.outDate">
                  <i class="fas fa-money-check-alt"></i> <strong class="ml-1">Atrasada *</strong>
                </span>
                <span v-if="invoice.status == 'OPENED' && !invoice.outDate">
                  <i class="fas fa-money-check-alt"></i> <strong class="ml-1">Em aberto</strong>
                </span>
                <span v-if="invoice.status == 'CANCELLED'">
                  <i class="fas fa-ban"></i> <strong class="ml-1">Cancelado</strong>
                </span>
                <span v-if="invoice.status == 'PAID'">
                  <i class="fas fa-check"></i> <strong class="ml-1">Pago</strong>
                </span>
                <span v-if="invoice.status == 'GENERATING'">
                  <i class="fas fa-spinner"></i> <strong class="ml-1">Gerando</strong>
                </span>
              </td>
              <td class="align-middle">
                <button type="button" class="btn btn-primary ml-1" @click="payInvoice(invoice)"
                  v-show="invoice.status =='OPENED'">Pagar</button>
                <button type="button" class="btn btn-light ml-1" @click="detailInvoice(index)"
                  v-show="invoice.status != 'CANCELLED'">Detalhes</button>
              </td>
            </tr>
  
            <tr v-show="invoices == null">
              <td colspan="5">
                Nenhuma informação de pagamento disponível.
              </td>
            </tr>
          </tbody>
        </table>
        <div class="col-md-12 little-text mb-5">* Haverá incidência de juros para faturas atrasadas.</div>
        <!--fim conteudo  -->
      </div>
    </div>
  
    <!-- detail -->
    <modal name="modal-detalhe-invoice" width="300px" height="auto" :scrollable="true">
      <form class="ml-3 mt-3 mr-3 mb-3">
        <h4 class="text-center">Detalhe da Fatura</h4>
        <p class="text-center little-text" v-show="actualInvoice.status == 'PAID'">
          <strong> Pago em: {{actualInvoice.paymentDate}} - {{actualInvoice.payAmountFmt}}</strong>
          <br><a :href="actualInvoice.nfeDownload" target="_blank">Download da Nota Fiscal</a>
        </p>
        <p class="text-center" v-show="actualInvoice.status == 'OPENED'">
          <strong>Linha Digitável</strong>
          <br>
          <span class="linhadigitavel">{{actualInvoice.barcodeTicket}}</span>
        </p>
        <ul class="list-group list-group-flush">
          <li class="list-group-item" v-for="detail in actualInvoice.details" :key="detail.id">
            {{detail.describe}} - {{detail.priceFmt}}
          </li>
        </ul>
        <div class="col-md-12 text-center">
          <button type="button" class="btn btn-primary mt-4" @click="closeModalDetailInvoice">Fechar</button>
        </div>
      </form>
    </modal>
  
    <!-- pagar -->
    <modal name="modal-pay-invoice" :adaptive="true" :max-width="500" height="auto">
      <div class="ml-3 mt-3 mr-3 mb-3">
        <h4 class="text-center mb-4">Escolha a forma de pagamento</h4>
        <div class="payment-buttons-container">
          <div class="payment-button-wrapper"
            v-if="currentInvoice.paymentType == 'TICKET' || currentInvoice.paymentType == 'TICKETS'">
            <button type="button" class="btn btn-payment" @click="payWithTicket">
              <i class="fas fa-barcode payment-icon"></i>
              <span>Boleto</span>
            </button>
          </div>
          <!-- <div class="payment-button-wrapper">
                      <button type="button" class="btn btn-payment" @click="payWithPix">
                        <i class="fas fa-qrcode payment-icon"></i>
                        <span>Pix</span>
                      </button>
                    </div> -->
        </div>
        <div class="col-md-12 text-center mt-3">
          <button type="button" class="btn btn-secondary" @click="closeModalPayInvoice">Cancelar</button>
        </div>
      </div>
    </modal>
  
    <!-- pix -->
    <modal name="modal-pix" :adaptive="true" :max-width="500" height="auto" @close="onModalPixClose">
      <div class="ml-3 mt-3 mr-3 mb-3">
        <h4 class="text-center mb-4">Pagamento com Pix</h4>
        <div class="payment-pix-container">
          <div class="image-container">
            <img :src="invoiceCharge.qrCode" alt="QR Code" />
          </div>
          <div class="pix-copy-paste-container mt-3">
            <div class="input-group">
              <input type="text" class="form-control" v-model="invoiceCharge.pixCopyPaste" readonly>
              <div class="input-group-append">
                <button class="btn btn-outline-secondary" type="button" @click="copyPixCode">
                  <i class="fas fa-copy"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="col-md-12 text-center">
            <span style="color: #8492a6;">
              Tempo restante: {{ remainingTime }}
            </span>
          </div>
          <div class="col-md-12 text-center">
            <span style="color: #8492a6;">
              <span> Valor: {{ Intl.NumberFormat('pt-BR', {style: 'currency', currency:
                'BRL'}).format(invoiceCharge.amount) }}</span>
            </span>
          </div>
          <div class="col-md-12 text-center mt-3">
            <button type="button" class="btn btn-secondary" @click="onModalPixClose">Voltar</button>
          </div>
          <div class="col-md-12 text-center">
            <span style="color: #8492a6; font-size:10px">
              * Pague durante o tempo, pois depois disso o pagamento em PIX será cancelado, sendo necessário gerar outro.
            </span>
          </div>
        </div>
      </div>
    </modal>
  
    <Rodape />
  </div>
</template>

<script>
import Topo from '@/components/Topo.vue';
import Rodape from '@/components/Rodape.vue';
import Menu from '@/components/Menu.vue';
import { differenceInSeconds } from 'date-fns';

export default {
  name: 'pagamento',
  components: {
    Topo, Menu, Rodape
  },
  data() {
    return {
      subscription: null,
      invoices: null,
      actualInvoice: {
        barcodeTicket: null,
        details: []
      },
      selecionadaSubscription: 0,
      currentInvoice: {},
      invoiceCharge: {},
      timer: null,
      remainingTime: '',
      expirationTimer: null
    }
  },
  methods: {
    loadSubscriptionData(idSubscription) {
      this.$clubApi.get('/subscription/load/' + idSubscription)
        .then((response) => this.subscription = response.data.object)
        .catch((error) => this.$notify({ type: 'warning', message: error.response.data.msg }));
    },
    loadInvoiceData(idSubscription) {
      this.$clubApi.get('/subscription/' + idSubscription + '/load/invoices')
        .then((response) => this.invoices = response.data.object)
        .catch((error) => this.$notify({ type: 'warning', message: error.response.data.msg }));
    },
    payInvoice(invoice) {
      this.$modal.show('modal-pay-invoice');
      this.currentInvoice = invoice;
    },
    printInvoices() {
      window.open("/pagamento/carne/" + this.selecionadaSubscription);
    },
    detailInvoice(index) {
      this.actualInvoice = this.invoices[index];
      this.$modal.show('modal-detalhe-invoice');
    },
    closeModalDetailInvoice() {
      this.$modal.hide('modal-detalhe-invoice');
    },
    closeModalPayInvoice() {
      this.currentInvoice = {};
      this.$modal.hide('modal-pay-invoice');
    },
    selecionarAssinatura(idSubscription) {
      this.invoices = [];
      this.selecionadaSubscription = (idSubscription === undefined) ? 0 : idSubscription;
      this.loadSubscriptionData(this.selecionadaSubscription);
      this.loadInvoiceData(this.selecionadaSubscription);
    },
    payWithTicket() {
      window.open(this.currentInvoice.urlTicket + '.pdf', '_blank');
      this.closeModalPayInvoice();
    },
    payWithPix() {
      const chargeInvoiceInfo = { paymentType: 'PIX' };
      this.$clubApi.post(`/invoice/${this.currentInvoice.id}/charge`, chargeInvoiceInfo)
        .then((response) => {
          this.$modal.show('modal-pix');
          this.$modal.hide('modal-pay-invoice');
          this.invoiceCharge = response.data.object;
          this.startPolling();
          this.startExpirationTimer();
        }).catch((error) => this.$notify({ type: 'warning', message: error.response.data.msg }));
    },
    copyPixCode() {
      navigator.clipboard.writeText(this.invoiceCharge.pixCopyPaste)
        .then(() => {
          this.$notify({ type: 'success', message: 'Código Pix copiado com sucesso!' });
        })
        .catch(() => this.$$notify({ type: 'warning', message: 'Erro ao copiar o código Pix.' }));
    },
    closeModalPix() {
      this.$modal.hide('modal-pix');
    },
    startPolling() {
      this.fetchApiData();
      this.timer = setInterval(this.fetchApiData, 5000);
    },
    stopPolling() {
      if (this.timer) {
        clearInterval(this.timer);
        this.stopExpirationTimer();
        this.timer = null;
      }
    },
    fetchApiData() {
      this.$clubApi.get(`/invoice/${this.currentInvoice.id}/charge/${this.invoiceCharge.chargeId}/sync`)
        .then((response) => this.ensurePayment(response.data.object))
        .catch((error) => this.$notify({ type: 'warning', message: error.response.data.msg }));
    },
    onModalPixClose() {
      this.stopPolling();
      this.stopExpirationTimer();
      this.closeModalPix();
      this.invoiceCharge = {};
    },
    ensurePayment(value) {
      this.currentState = value;

      switch (this.currentState.status) {
        case 'PAID':
          this.$notify({ type: 'success', message: "Fatura paga com sucesso." });
          this.$emit('onChange');
          break;
        case 'EXPIRED':
          this.$notify({ type: 'danger', message: "O tempo para pagar o pix acabou" });
          break;
        case 'WAITING':
          // Não faz nada, pois o polling continua
          return;
        default:
          this.$notify({ type: 'warning', message: "Status de pagamento desconhecido." });
      }

      this.stopPolling();
      this.$modal.show('modal-pix');
    },
    startExpirationTimer() {
      this.updateRemainingTime();
      this.expirationTimer = setInterval(this.updateRemainingTime, 1000);
    },
    stopExpirationTimer() {
      if (this.expirationTimer) {
        clearInterval(this.expirationTimer);
        this.expirationTimer = null;
      }
    },
    updateRemainingTime() {
      const now = new Date();
      let expireAt;

      try {
        // Parse the date string manually
        const [datePart, timePart] = this.invoiceCharge.expireAt.split(' ');
        const [day, month, year] = datePart.split('/');
        const [hours, minutes, seconds] = timePart.split(':');

        expireAt = new Date(year, month - 1, day, hours, minutes, seconds);

        if (isNaN(expireAt.getTime())) {
          throw new Error('Invalid date');
        }
      } catch (error) {
        console.error('Error parsing date:', error, this.invoiceCharge.expireAt);
        this.remainingTime = 'Data inválida';
        this.stopExpirationTimer();
        return;
      }

      const diffInSeconds = differenceInSeconds(expireAt, now);

      if (diffInSeconds <= 0) {
        this.remainingTime = 'Expirado';
        this.stopExpirationTimer();
      } else {
        const minutes = Math.floor(diffInSeconds / 60);
        const seconds = diffInSeconds % 60;
        this.remainingTime = `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
      }
    }
  },
  beforeDestroy() {
    this.stopPolling();
    this.stopExpirationTimer();
  }
}
</script>

<style scoped>
.payment-buttons-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
}

.payment-button-wrapper {
  flex: 0 0 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.btn-payment {
  width: 200px;
  height: 200px;
  background-color: white;
  border: 2px solid rgba(0, 0, 0, 0.125);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.btn-payment:hover {
  background-color: #f8f9fa;
  border-color: #999;
}

.payment-icon {
  font-size: 4rem;
  margin-bottom: 20px;
}

/* Responsividade para telas menores */
@media (max-width: 768px) {
  .payment-buttons-container {
    flex-direction: column;
    height: auto;
  }

  .payment-button-wrapper {
    flex: 0 0 100%;
    margin-bottom: 20px;
  }

  .btn-payment {
    width: 180px;
    height: 180px;
  }

  .payment-icon {
    font-size: 3rem;
  }
}

.table td {
  vertical-align: middle;
}

.image-container {
  width: 300px;
  height: 300px;
  overflow: hidden;
  margin-left: auto;
  margin-right: auto;
}

.image-container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.pix-copy-paste-container {
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
}

.input-group {
  display: flex;
}

.input-group .form-control {
  flex: 1;
}

.input-group-append .btn {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgb(206, 212, 218);
}

.input-group-append .btn i {
  margin-right: 0px;
}
</style>